import process from 'process';
import config from './config';

export const environment = process.env.NODE_ENV || 'development';

export const env = {
  baseUrl: config[environment].baseUrl,
};

export function getBaseUrl() {
  if (environment === 'development')
    return `${window.location.protocol}//${window.location.hostname}:8000`;

  return config[environment].baseUrl;
}

